import * as React from 'react';
import { LayoutItem } from '@oneaudi/unified-web-components';
import { OpeningHours } from './OpeningHours';
import { AddressAndContact } from './AddressAndContact';
import { PartnerBusinessCardPropsConfig } from './pbc-types';
import { PartnerBusinessCardHeader } from './PartnerBusinessCardHeader';
import { JsonLd } from './Json-ld';
import { PartnerContext } from '../../../contexts/partner-context';
import { DepartmentOpeningHours } from './PartnerData';
import { useTrackingManager } from '../../../hooks/useTrackingManager';

export const PartnerBusinessCardFixedNarrow = (
  config: PartnerBusinessCardPropsConfig,
): React.ReactElement => {
  const { partner, partnerHasOpeningHours } = React.useContext(PartnerContext);
  const { partnerId } = partner;
  const trackingManager = useTrackingManager();

  const {
    ctaBarButtonConfig = [],
    displayCtaBar = false,
    displayOpeningHours = false,
    displayFiveStarRating,
    fiveStarRating,
    isLinkedToPWS,
    showImage,
    showJsonLd,
    myAudiCtaConfig,
    errorMessage,
    flyoutCta,
  } = config;

  React.useEffect(() => {
    trackingManager?.impression(
      'fixed-narrow',
      partner?.nameEnhanced || '',
      partner?.openingHours?.departments as DepartmentOpeningHours[],
      config?.ctaBarButtonConfig,
    );
  }, [partnerId]);
  return (
    partner && (
      <>
        {showJsonLd && <JsonLd data={partner} />}
        <PartnerBusinessCardHeader
          partner={partner}
          isNarrow
          showImage={showImage}
          isLinkedToPWS={isLinkedToPWS}
          displayFiveStarRating={displayFiveStarRating}
          fiveStarRating={fiveStarRating}
          flyoutCta={flyoutCta}
        />
        <LayoutItem margin={['80px', 0, 0, 0]}>
          <AddressAndContact
            isNarrow
            isLinkedToPWS={isLinkedToPWS}
            displayCtaBar={displayCtaBar}
            ctaBarButtonConfig={ctaBarButtonConfig}
            myAudiCtaConfig={myAudiCtaConfig}
            errorMessage={errorMessage}
          />
        </LayoutItem>

        {displayOpeningHours && partnerHasOpeningHours && (
          <LayoutItem margin={['28px', 0, 0, 0]}>
            <OpeningHours data={partner} isNarrow />
          </LayoutItem>
        )}
      </>
    )
  );
};
